module.exports = __webpack_public_path__ + "media/svg/tg-f9c60a25.svg";